import { combineReducers } from 'redux';

import playback from './playback';
import state from './state';
import ui from './ui';


export default combineReducers({
  playback,
  state,
  ui,
});



// WEBPACK FOOTER //
// ./src/widget/redux/client/reducers/player/index.js